import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Link,
  Button,
} from "@mui/material";
// import "../signUp/SignUp.css";
import "../../assets/styles/LSFR.css";
import { Form, Field, FormikProvider, useFormik } from "formik";
import JSEncrypt from "jsencrypt";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import Logo from "../../assets/images/StyLogo.png";
import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
import { INTELLICONVO_API, API } from "../../utils/Axios.utils";
import { NO_ACCESS_CODE, normalizeRole } from "../../utils/roles";
import logger from "../../utils/logger";
import queryClient from "../../utils/queryClient";
const Login = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [alertType, setAlertType] = useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email must be a valid email address.")
      .trim()
      .email("Email must be a valid email address.")
      .trim()
      .required("Email is required."),

    password: Yup.string()
      // .matches(/^\S*$/, "Password must not contain spaces.") // No spaces allowed
      // .matches(
      //   /(?=.*[A-Z])/,
      //   "Password must contain at least one uppercase letter."
      // ) // At least one uppercase letter
      // .matches(
      //   /^(?=.*[a-z])/,
      //   "Password must contain at least one lowercase letter."
      // ) // At least one lowercase letter
      // .matches(/^(?=.*\d)/, "Password must contain at least one number.") // At least one number
      // .matches(
      //   /^(?=.*[!@#$%^&*])/,
      //   "Password must contain at least one special character."
      // ) // At least one special character
      // .min(8, "Password must be at least 8 characters long.") // Minimum password length of 8 characters
      // .max(20, "Password must be at most 20 characters long.")
      .required("Password is required."),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: async () => {
      await onSubmit(formik);
    },
  });

  const onSubmit = async (formik, takeover = false) => {
    //     const encryptor = new JSEncrypt();
    //     const privateKey = `-----BEGIN RSA PRIVATE KEY-----
    // MIICWwIBAAKBgFs4OHUSYAhdP8pE+XrqmeUR+UpBIuQmH4EUuRC+5zsyNC5H4vVV
    // 0TpsBs21G0nr2D8mZF8zFlInqsr2JJieBTxr9VfcP6WdnSwuc895hyhAlghhL/hn
    // xbApGDBj+AkUD/WzRARtXdgtwHoNVhR+JD3MRY8N0A7qZHeQ7JNDhYRZAgMBAAEC
    // gYATRfqvybUer00mGJK5xM3FV5nbdY3AtMldRZqgjiVfHYlm6etrOLmfZWm+lvBw
    // GvOyzBLTBoFF1HnCrmUnFeQ3EmjbIZPlSR8UQrjbZXOYHcDO41dK7xLWGGIsC8wd
    // rbcsGpT3U1WhIsjmfk3vmU/qSszbat1dCK7vom1j2CjrLQJBAJljwXxtXi80FT23
    // DnRmzDXoIYz6LUGQ6heEPby4ukM7+EwPdZPIn0yuw4lOvKmwdxm+M25LOuZc2rmb
    // xqlSH0cCQQCYPbxEJQ0e3pJ/bHWfCYRDwJ4wEo0BTw9n0YEQqVhI2nbC5z5w7K3X
    // 9D0CqXIPNyAJFe51Qohv2dTChDVq809fAkBzhmVAYGKyLIje7VLuqkmdRBKYygdx
    // vUIBqjCRRZPLdYxBRNdqEYygxXMxo+KF7wkUk2LK69AVldOKPV+3QMmbAkBAPyVZ
    // OK2dzl3Simnk0LZRhVL8hIee+sdMj7xA1MZeEFu4CrBuJWOD1B1/JxTsWN4bF3dH
    // YumDElFYOUT1unJPAkEAgcankqb0byKylQq7cZj6Pw12ckttfOHxkj0X7aBTV7wz
    // 2vTZgwpP8GpZwbBV6PEr6aypOhB3SmS7ugN2t7XDoA==
    // -----END RSA PRIVATE KEY-----`;
    //     encryptor.setPublicKey(privateKey);
    //     const encryptedPassword = encryptor.encrypt(formik.values.password); // encrypt

    //     if (!encryptedPassword) {
    //       throw new Error("Password encryption failed. Please try again.");
    //     }

    // 2. Prepare Data
    // const data = {
    //   email: formik.values.email,
    //   encryptedPassword: encryptedPassword, // Send encrypted password
    // };
    const data = {
      email: formik.values.email,
      password: formik.values.password, // Send encrypted password
      takeover_required: takeover,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    const email = formik.values.email;
    logger.info(`[Login] ${email}: signing in with Intelliconvo${takeover ? " (taking over the other session)" : ""}.`);

    await INTELLICONVO_API.post("/auth/user/login", data, headers)
      .then(async (res) => {
        const loginData = res?.data || {};

        // Intelliconvo allows one active session per user. When the account
        // is active elsewhere, this session stays inactive until it takes
        // over — so store nothing and sign in again with takeover (the other
        // session is signed out).
        if (loginData.takeover_required === true && !takeover) {
          logger.warn(`[Login] ${email}: already signed in elsewhere — taking over the session.`);
          await onSubmit(formik, true);
          return;
        }

        logger.info(`[Login] ${email}: Intelliconvo login succeeded (Intelliconvo user ${loginData.user_id}).`);

        if (!loginData.token) {
          throw new Error("Login did not return a session token. Please try again.");
        }

        // The API client reads the token from storage, so store the session
        // before asking the backend which TalentEngine role this user has.
        localStorage.setItem("userLoggedIn", JSON.stringify(loginData));
        localStorage.setItem("token", loginData.token);

          // Record login in audit log
          API.post("/api/users/login-audit").catch((err) => {
            console.warn("Failed to record login audit:", err);
          });

        // The role is decided by the backend (Intelliconvo TalentEngine app
        // entry, see backend utils/teRoles.js) — never from the login payload.
        logger.info(`[Login] ${email}: fetching TalentEngine role from the backend.`);
        const { data: tenantInfo } = await API.get("/api/users/tenant-info");
        const role = normalizeRole(tenantInfo?.role);
        if (!role) {
          throw new Error("Your TalentEngine role could not be determined. Please contact your admin.");
        }
        logger.info(`[Login] ${email}: TalentEngine role "${role}" (source: ${tenantInfo.roleSource}).`);

        localStorage.setItem(
          "userLoggedIn",
          JSON.stringify({ ...loginData, role, role_source: tenantInfo.roleSource })
        );
        // Nothing cached for an earlier session (e.g. its sidebar menu) may carry over.
        queryClient.clear();

        // Sync token with FastAPI automation backend
        try {
          const syncUrl = process.env.REACT_APP_FASTAPI_SYNC_URL;
          if (syncUrl) {
            await fetch(syncUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ token: loginData.token })
            });
            logger.info(`[Login] ${email}: token synced to the FastAPI automation service.`);
          } else {
            logger.warn("[Login] REACT_APP_FASTAPI_SYNC_URL is not set — skipping FastAPI token sync.");
          }
        } catch (syncErr) {
          logger.error(`[Login] ${email}: FastAPI token sync failed.`, syncErr);
        }

        setAlertContent(loginData?.message);
        setAlertType("success");
        setAlert(true);

        setTimeout(() => {
          navigate("/");
        }, 1500);
      })

      .catch((err) => {
        // Nothing from a failed login may stay behind in storage.
        localStorage.removeItem("userLoggedIn");
        localStorage.removeItem("token");

        const noAccess = err?.response?.status === 403 && err?.response?.data?.code === NO_ACCESS_CODE;
        if (noAccess) {
          logger.warn(`[Login] ${email}: signed in but has no TalentEngine access.`);
        } else {
          logger.error(`[Login] ${email}: login failed — ${err?.response?.data?.message || err?.message}`);
        }

        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "An error occurred. Please try again later.";

        // Ensure message is a string for the Notification component
        setAlertContent(typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage));
        setAlertType("error");
        setAlert(true);
      });
  };
  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <section className="signup-container">
          <div className="signup_logo" style={{ paddingTop: "20px" }}>
            <img src={Logo} width={380} height={100} alt="logo" />
          </div>
          <h1
            className="global_text login_text"
            style={{ textAlign: "center" }}
          >
            Login
          </h1>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              className="login_form_Fields"
              noValidate
              onSubmit={handleSubmit}
            >
              <Field
                as={TextField}
                fullWidth
                autoComplete="username"
                placeholder="name@gmail.com"
                name="email"
                type="email"
                {...getFieldProps("email")}
                size="small"
                style={{ marginBottom: "8%" }}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && errors.email}
              />

              <Field
                as={TextField}
                fullWidth
                autoComplete="off"
                placeholder="Enter your password here"
                name="password"
                type={showPassword ? "text" : "password"}
                //  error={props.errors.password && props.touched.password}
                size="small"
                {...getFieldProps("password")}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: {
                    height: "35px",
                  },
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
                style={{ marginBottom: "2.5%" }}
              //   className={classes.input_root}
              />
              {/* <div className="Signup_text"> */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Link
                  className="login-text-color"
                  variant="subtitle2"
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate("/forgotpassword", { replace: true })}
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Forgot Password?
                </Link>
              </div>

              <div className="signup_logo">
                <Button variant="contained" type="submit">
                  LOGIN
                </Button>
              </div>

              <Notification
                message={alertContent}
                open={alert}
                severity={alertType}
                onClose={handleAlert}
              />
            </Form>
          </FormikProvider>        </section>
      </Grid>
    </Grid>
  );
};
export default Login;
